module.exports = __webpack_public_path__ + "static/media/loginTabIcon.c3fdc47a.svg";